// extracted by mini-css-extract-plugin
module.exports = {"inputFields":"Template_inputFields__aU0iG"};